"use client";

import clsx from "clsx";
import React from "react";
import {useTranslation} from "react-i18next";
import Icon, {ICON_SIZES} from "@/components/library/Icon";

const secondaryButtonClass = clsx(
   "inline-flex items-center justify-center gap-2 self-start",
   "rounded-lg border border-300 bg-panel px-3 py-2 text-sm font-medium text-900",
   "transition-colors hover:border-primary/40 hover:text-primary",
   "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
);

const primaryButtonClass = clsx(
   "inline-flex items-center justify-center gap-2 self-start",
   "rounded-lg bg-primary px-3 py-2 text-sm font-medium text-white",
   "transition-colors hover:bg-primary/90",
   "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
);

/** Secondary "Open workflow" link to the builder for the linked workflow. */
export const OpenWorkflowButton: React.FC<{onClick: () => void}> = ({onClick}) => {
   const {t} = useTranslation("ask");
   return (
      <button type="button" onClick={onClick} className={secondaryButtonClass}>
         <Icon icon="arrow-up-right-from-square" size={ICON_SIZES.SM} />
         {t("workspace.buildWorkflow.open")}
      </button>
   );
};

/** Primary action (approve, retry, resume) with the workflow icon. */
export const HandoffActionButton: React.FC<{label: string; onClick: () => void}> = ({
   label,
   onClick,
}) => (
   <button type="button" onClick={onClick} className={primaryButtonClass}>
      <Icon icon="diagram-project" size={ICON_SIZES.SM} />
      {label}
   </button>
);
